import type { Section, StackGroup } from '../api/types';
import { Reveal } from './Reveal';
import styles from './TechStack.module.css';

interface TechStackProps {
  section: Section;
  groups: StackGroup[];
}

export function TechStack({ section, groups }: TechStackProps) {
  return (
    <section className="section" id="stack">
      <div className="shell">
        <Reveal className="sectionHead">
          <p className="eyebrow">{section.eyebrow}</p>
          <h2>{section.title}</h2>
          {section.body ? <p className="lead">{section.body}</p> : null}
        </Reveal>

        <Reveal className={styles.grid}>
          {groups.map((group) => (
            <div key={group.name} className={styles.group}>
              <h3 className={styles.groupName}>{group.name}</h3>
              <ul className={styles.items}>
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
